export function SvgDefs() {
  return (
    <defs>
      <pattern
        id="diagonal-stripe"
        patternUnits="userSpaceOnUse"
        width="5.5"
        height="5.5"
        patternTransform="rotate(45)"
      >
        <line x1="0" y="0" x2="0" y2="5.5" stroke="#EEEEEE" strokeWidth="1" />
      </pattern>
      <linearGradient id="#cool">
        <stop offset="5%" stopColor="red" />
        <stop offset="95%" stopColor="blue" />
      </linearGradient>
      <linearGradient id="wgw" x1="0" x2="1" y1="0" y2="0">
        <stop offset="0%" stopColor="white" />
        <stop offset="50%" stopColor="#dddddd" />
        <stop offset="100%" stopColor="white" />
      </linearGradient>
      <linearGradient id="grad2" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: 'rgb(255,0,0)', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: 'rgb(255,255,0)', stopOpacity: 1 }} />
      </linearGradient>
      <filter id="shadow">
        <feDropShadow dx="0.2" dy="0.2" stdDeviation="0.2" />
      </filter>
    </defs>
  );
}
